
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"22","cy":"22","r":"22","fill":"var(--status-svg-color)","fill-rule":"evenodd"}}),_c('path',{attrs:{"fill":"none","stroke-width":"1.5","stroke":"#fff","d":"M15 14h4v16h-4zM25 14h4v16h-4z"}})])
          )
        }
      }
    